import generateTypes from '../utils/generateTypes';

export const GET_BREAKOUTS = generateTypes('GET_BREAKOUTS');
export const RESET_BREAKOUTS = generateTypes('RESET_BREAKOUTS');
